import { message } from "antd";
import axiosInstance from "../../../helpers/axios";
import { responseDataFormate } from "../../../helpers/bycrypt";

interface CreateProductTagParams {
  payload: any;
  onSuccess: (data: any) => void;
  onError: () => void;
}

export const createProductTagAPI =
  ({ payload, onSuccess, onError }: CreateProductTagParams) =>
  async (dispatch: any) => {
    try {
      const response = await axiosInstance.post("/product-tags", payload);

      let result = responseDataFormate(response.data);

      if (result?.success) {
        message.success(result?.message);
        onSuccess?.(result.data);
      } else {
        message.error(result?.message);
        onError?.();
      }
    } catch (error: any) {
      console.error("Create Product Tag error:", error);
      onError?.();

      const errorMessage = error?.response?.data?.message;
      message.error(errorMessage);
    }
  };

export interface ProductTagFilterParams {
  page?: number;
  limit?: number;
  search?: string;
  id?: string;
  sortBy?: string | null;
  sortOrder?: string | null;
}

interface GetProductTagListParams {
  filters: ProductTagFilterParams;
  signal?: AbortSignal;
  onSuccess?: (data: any) => void;
  onError?: () => void;
}

export const getProductTagListAPI =
  ({ filters, onSuccess, onError, signal }: GetProductTagListParams) =>
  async (dispatch: any) => {
    try {
      const response = await axiosInstance.get("/product-tags", {
        params: filters,
        signal,
      });

      let result = responseDataFormate(response.data);

      if (result?.success) {
        onSuccess?.(result.data);
      } else {
        message.error(result?.message);
        onError?.();
      }
    } catch (error: any) {
      if (error.code === "ERR_CANCELED" || error.name === "AbortError") return;
      console.error("Get Product Tags List Error:", error);
      message.error(error?.response?.data?.message);
      onError?.();
    }
  };

interface ReorderProductTagParams {
  payload: any; // Payload now includes 'id' inside it
  onSuccess: (data: any) => void;
  onError: () => void;
}

export const reorderProductTagAPI =
  ({ payload, onSuccess, onError }: ReorderProductTagParams) =>
  async (dispatch: any) => {
    try {
      const response = await axiosInstance.put(
        "/product-tags/reorder",
        payload,
      );

      let result = responseDataFormate(response.data);

      if (result?.success) {
        message.success(result?.message);
        onSuccess?.(result.data);
      } else {
        message.error(result?.message);
        onError?.();
      }
    } catch (error: any) {
      console.error("Reorder error:", error);
      onError?.();

      const errorMessage = error?.response?.data?.message;
      message.error(errorMessage);
    }
  };

interface UpdateProductTagParams {
  payload: any; // Payload now includes 'id' inside it
  onSuccess: (data: any) => void;
  onError: () => void;
}

export const updateProductTagAPI =
  ({ payload, onSuccess, onError }: UpdateProductTagParams) =>
  async (dispatch: any) => {
    try {
      const response = await axiosInstance.put("/product-tags/", payload);

      let result = responseDataFormate(response.data);

      if (result?.success) {
        message.success(result?.message);
        onSuccess?.(result.data);
      } else {
        message.error(result?.message);
        onError?.();
      }
    } catch (error: any) {
      console.error("Update Product Tag error:", error);
      onError?.();

      const errorMessage = error?.response?.data?.message;
      message.error(errorMessage);
    }
  };

interface DeleteProductTagParams {
  id: string;
  onSuccess: () => void;
  onError: () => void;
}

export const deleteProductTagAPI =
  ({ id, onSuccess, onError }: DeleteProductTagParams) =>
  async (dispatch: any) => {
    try {
      const response = await axiosInstance.delete("/product-tags", {
        data: { id: id },
      });

      let result = responseDataFormate(response.data);

      if (result?.success) {
        message.success(result?.message);
        onSuccess?.();
      } else {
        message.error(result?.message);
        onError?.();
      }
    } catch (error: any) {
      console.error("Delete Product Tag error:", error);
      onError?.();

      const errorMessage = error?.response?.data?.message;
      message.error(errorMessage);
    }
  };
